// Tour group languages (wycieczki) — flags & labels for staff UI.
// Mirrors landing-wycieczki/src/lib/tourLanguages.ts. Values in DB are free
// text and historically mixed: codes ('en') and names ('english', 'polski').

export const TOUR_LANGUAGES = [
  { code: 'pl', flag: '🇵🇱', native: 'Polski', namePl: 'polski' },
  { code: 'en', flag: '🇬🇧', native: 'English', namePl: 'angielski' },
  { code: 'ru', flag: '🇷🇺', native: 'Русский', namePl: 'rosyjski' },
  { code: 'de', flag: '🇩🇪', native: 'Deutsch', namePl: 'niemiecki' },
  { code: 'fr', flag: '🇫🇷', native: 'Français', namePl: 'francuski' },
  { code: 'es', flag: '🇪🇸', native: 'Español', namePl: 'hiszpański' },
  { code: 'it', flag: '🇮🇹', native: 'Italiano', namePl: 'włoski' },
  { code: 'ua', flag: '🇺🇦', native: 'Українська', namePl: 'ukraiński' },
];

const ALIASES: Record<string, string> = {
  polski: 'pl', polish: 'pl',
  english: 'en', angielski: 'en',
  russian: 'ru', rosyjski: 'ru',
  german: 'de', niemiecki: 'de', deutsch: 'de',
  french: 'fr', francuski: 'fr',
  spanish: 'es', hiszpanski: 'es', 'hiszpański': 'es',
  italian: 'it', wloski: 'it', 'włoski': 'it',
  ukrainian: 'ua', uk: 'ua', ukrainski: 'ua', 'ukraiński': 'ua',
};

export function normalizeLangCode(value?: string | null): string {
  const v = (value || 'pl').trim().toLowerCase();
  return ALIASES[v] || v;
}

export function langFlag(value?: string | null): string {
  const code = normalizeLangCode(value);
  return TOUR_LANGUAGES.find(l => l.code === code)?.flag || '🏳️';
}
